import React, { useEffect, useState } from 'react';
import { testDatabaseConnection, testAnnouncementsAccess } from '../utils/FirebaseUtils';

const FirebaseConnectionStatus = () => {
  const [connectionStatus, setConnectionStatus] = useState({ testing: true });
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const checkConnection = async () => {
      // Test general database connection
      const dbConnectionResult = await testDatabaseConnection();
      
      // If database connection is successful, test announcements access
      let announcementsResult = { success: false, message: 'Not tested' };
      if (dbConnectionResult.success && dbConnectionResult.connected) {
        announcementsResult = await testAnnouncementsAccess();
      }
      
      setConnectionStatus({
        testing: false,
        dbConnection: dbConnectionResult,
        announcementsAccess: announcementsResult,
        timestamp: new Date().toISOString()
      });
    };

    checkConnection();
  }, []);

  // If the component is just used for logging purposes, return null
  // return null;

  // Uncomment the code below to show a visual status indicator
  return (
    <div className="firebase-status" style={{ display: 'none' }}>
      {connectionStatus.testing ? (
        <p>Testing Firebase connection...</p>
      ) : (
        <>
          <div 
            className={`status-indicator ${
              connectionStatus.dbConnection.success && 
              connectionStatus.announcementsAccess.success 
                ? 'status-success' 
                : 'status-error'
            }`}
          />
          {showDetails && (
            <div className="status-details">
              <p>Database: {connectionStatus.dbConnection.message}</p>
              <p>Announcements: {connectionStatus.announcementsAccess.message}</p>
              <p>Last checked: {connectionStatus.timestamp}</p>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default FirebaseConnectionStatus; 